import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=7dd629fd&scoped=true&"
import script from "./Skeleton.vue?vue&type=script&lang=ts&"
export * from "./Skeleton.vue?vue&type=script&lang=ts&"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=7dd629fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd629fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd629fd')) {
      api.createRecord('7dd629fd', component.options)
    } else {
      api.reload('7dd629fd', component.options)
    }
    module.hot.accept("./Skeleton.vue?vue&type=template&id=7dd629fd&scoped=true&", function () {
      api.rerender('7dd629fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Skeleton.vue"
export default component.exports